import {
  CreateFulfillmentOrderSchema,
  type ICreateFulfillmentOrder,
} from "@redotech/redo-model/fulfillments/create-fulfillment-order";
import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { TagSchema } from "@redotech/redo-model/tag";
import * as z from "zod/v4";

export const createManualFulfillmentGroups = {
  name: "createManualFulfillmentGroups" as const,
  input: z.object({
    fulfillmentOrders: z.array(
      CreateFulfillmentOrderSchema as ICreateFulfillmentOrder,
    ),
    shipmentTags: z.array(TagSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema).nullish(),
  }),
};
